/* eslint no-param-reassign: "error" */
import {
  createSlice,
} from '@reduxjs/toolkit';

import type {
  AttendRegisterJsonPub,
  AttendRegisterJsonPvt,
} from '@/domain/attendRegister/service/entity/attendRegisterEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { DeleteOutputType, EntitySubscribeType } from '@/infra/appsync';
import type { AttendRegisterStateType } from '@/types/domain/attendRegister/redux';
import type { SheetJson } from '@/types/domain/attendance/entities/sheetEntity';
import type {
  PayloadAction,
} from '@reduxjs/toolkit';

import { service } from '@/share';

const initialState: AttendRegisterStateType = {
  attendRegisterList: [],
  sheetList: [],
  year: new Date().getFullYear(),
  month: new Date().getMonth() + 1,
};

/**
 * 出席登録Slice
 */
export const attendRegisterSlice = createSlice({
  name: 'attendRegister',
  initialState,
  reducers: {
    /** 登園リスト */
    setAttendRegisterList:
      (state, action: PayloadAction<{
        nextToken: string,
        items: Array<EntityDataPubType<AttendRegisterJsonPvt, AttendRegisterJsonPub>>,
      }>) => {
        state.attendRegisterList = action.payload.items;
      },
    /** 出席リスト */
    setSheetList:
      (state, action: PayloadAction<{
        nextToken: string,
        items: SheetJson[],
      }>) => {
        state.sheetList = action.payload.items;
      },
    /** 年月 */
    setYearMonth: (state, action: PayloadAction<{ year: number, month: number }>) => {
      state.year = action.payload.year;
      state.month = action.payload.month;
    },
    /** 作成 */
    createAttendRegisterStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.attendRegisterList = service.attendRegister.createAttendRegisterStore(
        state.attendRegisterList,
        action.payload,
        undefined,
      );
    },
    /** 更新 */
    updateAttendRegisterStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.attendRegisterList = service.attendRegister.updateAttendRegisterStore(
        state.attendRegisterList,
        action.payload,
      );
    },
    /** 削除 */
    deleteAttendRegisterStore: (
      state,
      action: PayloadAction<DeleteOutputType>,
    ) => {
      state.attendRegisterList = service.attendRegister.deleteAttendRegisterStore(
        state.attendRegisterList,
        action.payload,
      );
    },
    /** 作成 */
    createSheetStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.sheetList = service.attendRegister.createSheetStore(
        state.sheetList,
        action.payload,
        undefined,
      );
    },
    /** 更新 */
    updateSheetStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.sheetList = service.attendRegister.updateSheetStore(
        state.sheetList,
        action.payload,
      );
    },
    /** 削除 */
    deleteSheetStore: (
      state,
      action: PayloadAction<DeleteOutputType>,
    ) => {
      state.sheetList = service.attendRegister.deleteSheetStore(
        state.sheetList,
        action.payload,
      );
    },
  },
});
